/*
  Art Finder quiz
  ---------------------------------------------------------------------------
  ALLE INHOUD VAN DE QUIZ STAAT IN ART_FINDER_CONFIG HIERONDER.
  Vragen, antwoorden, tags, synoniemen en gewichten pas je daar aan.
  De rest van dit bestand hoef je niet te raken.
  ---------------------------------------------------------------------------
*/

const ART_FINDER_CONFIG = {
  /*
    Gewichten per vraaggroep. Hoger = zwaarder mee in de score.
    Het onderwerp is sinds 23 sep 2026 een harde filter (zie score());
    het gewicht bepaalt alleen nog de volgorde binnen dat onderwerp.
  */
  weights: {
    subject: 3,
    colourPreference: 2,
    mood: 1,
    colour: 1,
    style: 1,
    role: 1,
    size: 0.5,
  },

  /*
    Synoniemen: een criterium telt als match zodra EEN van deze tags
    op het product staat. Hoofdletters en spaties maken niet uit,
    "Abstract art" en "abstract-art" zijn hetzelfde.
  */
  synonyms: {
    abstract: ['abstract', 'abstract-art'],
    colourful: ['colourful', 'colorful'],
    dark: ['dark', 'moody'],
    graphic: ['graphic', 'graphical'],
  },

  questions: [
    {
      id: 'mood',
      group: 'mood',
      title: 'How do you want your art to make the room feel?',
      answers: [
        { label: 'Alive and full of energy', tags: ['energetic'], phrase: 'energy' },
        { label: 'Calm and grounded', tags: ['calm'], phrase: 'calm, grounded work' },
        { label: 'Warm and joyful', tags: ['joyful'], phrase: 'warmth and joy' },
        { label: 'Dramatic and powerful', tags: ['dramatic'], phrase: 'drama' },
      ],
    },
    {
      id: 'colour',
      group: 'colour',
      title: 'What happens when colour enters the room?',
      answers: [
        { label: 'The more, the better', tags: ['colourful'], phrase: 'colour' },
        { label: 'Give me a few strong colours', tags: ['bold'], phrase: 'strong colour' },
        { label: 'I prefer softer, quieter colours', tags: ['soft'], phrase: 'soft, quiet colour' },
        { label: 'I love deep and moody tones', tags: ['dark'], phrase: 'deep, moody tones' },
      ],
    },
    {
      id: 'subject',
      group: 'subject',
      title: 'What are you naturally drawn to?',
      answers: [
        /*
          DE HARDE GRENS IS DIEREN VERSUS ABSTRACT (besluit Tim, 23 sep 2026).
          "set" noemt de toegestane werken (zie subjectSets hieronder); die
          grens wordt nergens versoepeld, ook niet bij een andere kleur.
          Animals in Cars is daarbinnen een ZEER STERKE voorkeur voor de tag
          "Classic Cars Go Everywhere": autowerken eerst, andere dieren alleen
          als aanvulling wanneer er in de uitslag geen autowerk meer past.
        */
        { label: 'Animals', tags: ['animals'], phrase: 'animals', set: 'dieren' },
        { label: 'Animals in Cars', tags: ['classic-cars-go-everywhere'], phrase: 'animals in cars', set: 'dieren', voorkeur: 'classic-cars-go-everywhere' },
        { label: 'Abstract', tags: ['abstract'], phrase: 'abstract work', set: 'abstract' },
        { label: 'Surprise me', tags: [], phrase: '' },
      ],
    },
    {
      id: 'style',
      group: 'style',
      title: 'Which sounds most like you?',
      answers: [
        { label: 'Playful and a little unexpected', tags: ['playful'], phrase: 'playful surprises' },
        { label: 'Bold and expressive', tags: ['expressive'], phrase: 'bold, expressive work' },
        { label: 'Clean and striking', tags: ['graphic'], phrase: 'clean, graphic work' },
        { label: 'Organic and free', tags: ['organic'], phrase: 'organic shapes' },
      ],
    },
    {
      id: 'role',
      group: 'role',
      title: 'What role should the artwork play in the room?',
      answers: [
        { label: 'I want it to be the star', tags: ['statement'], phrase: 'statement pieces' },
        { label: 'I want it to add warmth and personality', tags: ['warm'], phrase: 'warmth and personality' },
        { label: 'I want something that makes me smile', tags: ['quirky'], phrase: 'work that makes you smile' },
        { label: 'I want something I can keep discovering', tags: ['layered'], phrase: 'layered work you keep discovering' },
      ],
      /*
        VRAAG 5 HANGT AF VAN VRAAG 3 (besluit Tim, 26 sep 2026). De sleutel is
        de "set" van het onderwerpantwoord. Abstract krijgt een eigen vraag;
        Animals, Animals in Cars en Surprise me houden de vraag hierboven.
        Kiest de bezoeker bij vraag 3 een onderwerp met een andere variant,
        dan vervalt het antwoord op vraag 5 en moet hij hem opnieuw kiezen.

        De tags zijn bestaande producttags op de abstracte werken:
          layered            gelaagd, complex
          graphic            krachtig, eenvoudige vormen
          organic + energetic expressief, beweging en textuur
          calm + soft        rustig, veel ruimte
      */
      variants: {
        abstract: {
          title: 'What keeps you looking at an artwork?',
          answers: [
            { label: 'Layers and details to discover', tags: ['layered'], phrase: 'layers and details to discover' },
            { label: 'Bold, simple forms', tags: ['graphic'], phrase: 'bold, simple forms' },
            { label: 'Movement and texture', tags: ['organic', 'energetic'], phrase: 'movement and texture' },
            { label: 'Space and simplicity', tags: ['calm', 'soft'], phrase: 'space and simplicity' },
          ],
        },
      },
    },
    {
      id: 'size',
      group: 'size',
      title: 'How much space do you want the artwork to claim?',
      /*
        Formaat komt uit de daadwerkelijk beschikbare Size-varianten.
        Een formaat-tag op het product (xl / large-medium / small-medium)
        overrulet de varianten, mocht je die ooit willen zetten.
      */
      answers: [
        { label: 'Go big', tags: ['xl'], size: 'xl', phrase: 'big work' },
        {
          label: 'A substantial piece, but not enormous',
          tags: ['large-medium'],
          size: 'large-medium',
          phrase: 'substantial pieces',
        },
        {
          label: 'Something more compact',
          tags: ['small-medium'],
          size: 'small-medium',
          phrase: 'compact pieces',
        },
        { label: "I'm flexible, show me what fits my taste", tags: [], size: null, phrase: '' },
      ],
    },
    {
      id: 'colourPreference',
      group: 'colourPreference',
      /*
        De laatste stap. Dit zijn je bestaande Shopify-kleurtags; een regel
        weghalen haalt de kleur uit de quiz, meer is het niet.

        Bovenaan staan de aanbevolen kleuren: die van de matches die de
        eerdere antwoorden opleveren (de uitslag die de bezoeker krijgt als
        hij hier niets kiest). Daaronder de andere kleuren waarin een passend
        werk bestaat. Uit BEIDE rijen samen mag de bezoeker zoveel kleuren
        kiezen als hij wil, en elke kleur weer uitzetten (besluit Tim,
        24 sep 2026). Niets kiezen betekent: de oorspronkelijke matches.
        Bij gekozen kleuren eerst de werken in één of meer daarvan, aangevuld
        tot zes binnen het onderwerp. "No preference" (noPreferenceLabel) zet alle kleuren uit en geeft
        de gewone uitslag. Het onderwerp (Animals / Animals in Cars /
        Abstract) wordt NOOIT losgelaten (zie kleurResultaten).
        lightSwatch: true zet het vinkje in het zwart, voor lichte kleuren.
      */
      type: 'colours',
      title: 'Your answers led to artworks featuring these colours:',
      subtitle: "Skip this step if colour doesn't matter.",
      noPreferenceLabel: 'No preference',
      otherTitle: 'Prefer a different colour?',
      otherSubtitle: 'Choose from the colours below. Your results may match some of your other preferences less closely.',
      answers: [
        { label: 'Blue', tags: ['blue'], swatch: '#2f6fb0' },
        { label: 'Red', tags: ['red'], swatch: '#c8322b' },
        { label: 'Pink', tags: ['pink'], swatch: '#e26ea8' },
        { label: 'Orange', tags: ['orange'], swatch: '#e8842a' },
        { label: 'Yellow', tags: ['yellow'], swatch: '#e8c531', lightSwatch: true },
        { label: 'Green', tags: ['green'], swatch: '#3f8f4a' },
        { label: 'Turquoise', tags: ['turquoise'], swatch: '#2fa6a0' },
        { label: 'Teal', tags: ['teal'], swatch: '#1f7a8c' },
        { label: 'Purple', tags: ['purple'], swatch: '#7a4fa3' },
        { label: 'Lilac', tags: ['lilac'], swatch: '#b9a0d8', lightSwatch: true },
        { label: 'Brown', tags: ['brown'], swatch: '#8a5a34' },
        { label: 'Beige', tags: ['beige'], swatch: '#ddcdb4', lightSwatch: true },
        { label: 'Grey', tags: ['grey'], swatch: '#9a9a9a', lightSwatch: true },
        { label: 'Black', tags: ['black'], swatch: '#1a1a1a' },
        { label: 'White', tags: ['white'], swatch: '#ffffff', lightSwatch: true },
      ],
    },
  ],

  /*
    Alleen producten die de bezoeker op dit moment ook echt kan kopen mogen
    worden aanbevolen. Shopify's "available" per variant is true zodra de
    klant kan afrekenen: bij voorraad, bij uitgeschakelde voorraadtracking,
    en wanneer verkoop bij nul is toegestaan. Het is dus niet hetzelfde als
    "voorraad groter dan nul". Concepten en niet-gepubliceerde producten
    staan sowieso niet in de productfeed.
  */
  requirePurchasable: true,

  /*
    De harde onderwerpsets. Een werk hoort bij een set als het minstens één
    tag uit anyOf draagt en geen enkele uit noneOf. Animals in Cars hoort bij
    de dieren, ook een autowerk zonder de tag "animals".
  */
  /* Voorvoegsel voor een kleur die in een werk alleen als accent voorkomt, bv. accent-orange. */
  accentPrefix: 'accent-',

  subjectSets: {
    dieren: { anyOf: ['animals', 'classic-cars-go-everywhere'], noneOf: ['abstract'] },
    abstract: { anyOf: ['abstract'], noneOf: ['animals', 'classic-cars-go-everywhere'] },
  },

  /*
    Ontdubbelen: van hetzelfde kunstwerk hoort maar één productversie in de
    resultaten te staan, niet het grote canvas én de 30x30 ernaast.

    De sleutel van een kunstwerk is de titel zonder de segmenten die alleen
    de PRODUCTVORM aanduiden. Segmenten die iets anders zeggen blijven
    staan, zodat "Mousy | Lime" en "Mousy | Purple" twee verschillende
    werken blijven. Een nieuwe productvorm voeg je hieronder toe.
  */
  dedupe: {
    enabled: true,
    formSegments: [
      'canvas print',
      'original painting',
      'paper print',
      'fine art paper print',
      'limited edition',
      'fine art canvas print',
    ],
  },

  /*
    Grenzen van het formaatfilter, in centimeters, gemeten over de langste
    zijde van een koopbare variant. De drie categorieën sluiten op elkaar aan.
    Kiest de bezoeker een formaat, dan vallen werken die daar niet in
    leverbaar zijn volledig af; "I'm flexible" filtert niets.
  */
  sizeFilter: {
    xlFrom: 120,
    largeFrom: 70,
  },

  /* Grenzen in centimeters voor het afleiden van formaat uit varianten. */
  sizeBuckets: {
    xl: { idealFrom: 120, partialFrom: 100 },
    'large-medium': { idealFrom: 70, idealTo: 119, partialFrom: 60, partialTo: 130 },
    'small-medium': { idealTo: 50, partialTo: 70 },
  },
};

/* ------------------------------------------------------------------------ */
/* Vanaf hier alleen techniek.                                              */
/*
  NEDERLANDS (17 okt 2026)
  ---------------------------------------------------------------------------
  Op de Nederlandse site (/nl/, <html lang="nl">) vervangen we alleen de
  zichtbare teksten. Tags, gewichten, sets en de rest van de logica blijven
  precies gelijk aan de Engelse quiz. De antwoorden staan in DEZELFDE
  VOLGORDE als hierboven: [label, phrase]. Pas je hierboven een antwoord aan
  of voeg je er een toe, doe dat dan hier ook.
  "phrase" vult de zin "...die het best passen bij jouw voorkeur voor ___".
*/
const AF_NL = /^nl\b/i.test(document.documentElement.lang || '');
const afT = (en, nl) => (AF_NL ? nl : en);

const ART_FINDER_NL = {
  questions: {
    mood: {
      title: 'Welk gevoel moet je kunst de ruimte geven?',
      answers: [
        ['Levendig en vol energie', 'energie'],
        ['Rustig en geaard', 'rustig, geaard werk'],
        ['Warm en vrolijk', 'warmte en vrolijkheid'],
        ['Dramatisch en krachtig', 'drama'],
      ],
    },
    colour: {
      title: 'Wat gebeurt er als er kleur in de ruimte komt?',
      answers: [
        ['Hoe meer, hoe beter', 'kleur'],
        ['Geef mij maar een paar sterke kleuren', 'sterke kleuren'],
        ['Ik hou meer van zachte, rustige kleuren', 'zachte, rustige kleuren'],
        ['Ik hou van diepe, donkere tinten', 'diepe, donkere tinten'],
      ],
    },
    subject: {
      title: 'Waar voel je je vanzelf toe aangetrokken?',
      answers: [
        ['Dieren', 'dieren'],
        ["Dieren in auto's", "dieren in auto's"],
        ['Abstract', 'abstract werk'],
        ['Verras me', ''],
      ],
    },
    style: {
      title: 'Wat past het best bij jou?',
      answers: [
        ['Speels en een beetje onverwacht', 'speelse verrassingen'],
        ['Krachtig en expressief', 'krachtig, expressief werk'],
        ['Strak en opvallend', 'strak, grafisch werk'],
        ['Organisch en vrij', 'organische vormen'],
      ],
    },
    role: {
      title: 'Welke rol moet het kunstwerk in de ruimte spelen?',
      answers: [
        ['Het mag de ster zijn', 'werken die de show stelen'],
        ['Het moet warmte en persoonlijkheid geven', 'warmte en persoonlijkheid'],
        ['Ik wil iets waar ik om moet glimlachen', 'werk waar je om moet glimlachen'],
        ['Ik wil iets waarin ik blijf ontdekken', 'gelaagd werk waarin je blijft ontdekken'],
      ],
      variants: {
        abstract: {
          title: 'Waardoor blijf je naar een kunstwerk kijken?',
          answers: [
            ['Lagen en details om te ontdekken', 'lagen en details om te ontdekken'],
            ['Krachtige, eenvoudige vormen', 'krachtige, eenvoudige vormen'],
            ['Beweging en textuur', 'beweging en textuur'],
            ['Ruimte en eenvoud', 'ruimte en eenvoud'],
          ],
        },
      },
    },
    size: {
      title: 'Hoeveel ruimte mag het kunstwerk innemen?',
      answers: [
        ['Groot, graag', 'groot werk'],
        ['Een flink werk, maar niet enorm', 'flinke werken'],
        ['Iets compacters', 'compacte werken'],
        ['Maakt niet uit, laat zien wat bij mijn smaak past', ''],
      ],
    },
    colourPreference: {
      title: 'Je antwoorden leiden naar kunstwerken met deze kleuren:',
      subtitle: 'Maakt kleur je niet uit? Sla deze stap dan over.',
      noPreferenceLabel: 'Geen voorkeur',
      otherTitle: 'Liever een andere kleur?',
      otherSubtitle: 'Kies uit de kleuren hieronder. Je resultaten passen dan misschien iets minder goed bij je andere voorkeuren.',
      /* per tag, zodat de volgorde van de kleuren niet uitmaakt */
      colours: {
        blue: 'Blauw',
        red: 'Rood',
        pink: 'Roze',
        orange: 'Oranje',
        yellow: 'Geel',
        green: 'Groen',
        turquoise: 'Turquoise',
        teal: 'Petrol',
        purple: 'Paars',
        lilac: 'Lila',
        brown: 'Bruin',
        beige: 'Beige',
        grey: 'Grijs',
        black: 'Zwart',
        white: 'Wit',
      },
    },
  },
  /* Nederlandse producttitels gebruiken andere woorden voor de productvorm. */
  formSegments: ['canvasprint', 'origineel schilderij', 'papierprint', 'print op fine art papier', 'beperkte oplage', 'fine art canvasprint'],
};

function afPasNederlandsToe(config, nl) {
  const zet = (doel, bron) => {
    if (!bron) return;
    if (bron.title) doel.title = bron.title;
    (bron.answers || []).forEach(([label, phrase], index) => {
      const answer = doel.answers[index];
      if (!answer) return;
      answer.label = label;
      answer.phrase = phrase;
    });
  };
  config.questions.forEach((question) => {
    const bron = nl.questions[question.id];
    if (!bron) return;
    zet(question, bron);
    ['subtitle', 'noPreferenceLabel', 'otherTitle', 'otherSubtitle'].forEach((key) => {
      if (bron[key]) question[key] = bron[key];
    });
    if (bron.colours) {
      question.answers.forEach((answer) => {
        const label = bron.colours[answer.tags[0]];
        if (label) answer.label = label;
      });
    }
    Object.keys(bron.variants || {}).forEach((key) => {
      if (question.variants && question.variants[key]) zet(question.variants[key], bron.variants[key]);
    });
  });
  config.dedupe.formSegments = config.dedupe.formSegments.concat(nl.formSegments);
}

if (AF_NL) afPasNederlandsToe(ART_FINDER_CONFIG, ART_FINDER_NL);

/* ------------------------------------------------------------------------ */

const AF_PAGE_SIZE = 250;
const AF_MAX_PAGES = 4;

function afNormaliseTag(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

function afEscape(value) {
  const div = document.createElement('div');
  div.textContent = value == null ? '' : String(value);
  return div.innerHTML;
}

/*
  Leest de centimeters uit een variantnaam. Vangt alle notaties die in de
  winkel voorkomen:
      "70 x 70 cm / 28 x 28″"   -> 70   (het inch-deel achter de / telt niet mee)
      "(A1) 84.1 x 59.4 cm"     -> 84,1
      "5 x 5 x 8 cm"            -> 8    (drie maten, grootste telt)
  Geeft de grootste zijde per maat terug.
*/
function afVariantSizes(variant) {
  const sizes = [];
  [variant.option1, variant.option2, variant.option3, variant.title].forEach((field) => {
    if (!field) return;
    const text = String(field).split('/')[0];
    const matches = text.matchAll(/([\d.]+)\s*[x×]\s*([\d.]+)(?:\s*[x×]\s*([\d.]+))?\s*cm/gi);
    for (const match of matches) {
      const dims = [match[1], match[2], match[3]].filter(Boolean).map(Number).filter((n) => Number.isFinite(n) && n > 0);
      if (dims.length) sizes.push(Math.max(...dims));
    }
  });
  return sizes;
}

/* Kleinste en grootste maat over alle varianten; gebruikt voor de puntentelling. */
function afSizeRange(product) {
  const sizes = [];
  (product.variants || []).forEach((variant) => sizes.push(...afVariantSizes(variant)));
  if (!sizes.length) return null;
  return { min: Math.min(...sizes), max: Math.max(...sizes) };
}

/*
  In welke formaatcategorie valt een maat? De drie categorieën sluiten op
  elkaar aan, zodat elke maat er in precies één valt.
*/
function afBucketForSize(largest) {
  const grenzen = ART_FINDER_CONFIG.sizeFilter;
  if (largest >= grenzen.xlFrom) return 'xl';
  if (largest >= grenzen.largeFrom) return 'large-medium';
  return 'small-medium';
}

/*
  Is dit werk daadwerkelijk te koop in de gevraagde categorie? Alleen
  koopbare varianten tellen, en één passende variant is genoeg.
  Een werk zonder leesbare maat kan nergens in vallen: we weten het niet,
  dus we beweren het niet.
*/
function afMatchesSizeBucket(product, bucket) {
  if (!bucket) return true;
  return (product.variants || []).some((variant) => {
    if (variant.available !== true) return false;
    return afVariantSizes(variant).some((largest) => afBucketForSize(largest) === bucket);
  });
}

function afSizeScore(bucket, product, tagSet) {
  if (!bucket) return 0;

  /* Expliciete tag wint altijd. */
  if (tagSet.has(bucket)) return 1;

  const range = afSizeRange(product);
  if (!range) return 0;

  const rules = ART_FINDER_CONFIG.sizeBuckets[bucket];
  if (!rules) return 0;

  if (bucket === 'xl') {
    if (range.max >= rules.idealFrom) return 1;
    if (range.max >= rules.partialFrom) return 0.5;
    return 0;
  }

  if (bucket === 'large-medium') {
    if (range.max >= rules.idealFrom && range.max <= rules.idealTo) return 1;
    if (range.max >= rules.partialFrom && range.min <= rules.partialTo) return 0.5;
    return 0;
  }

  if (bucket === 'small-medium') {
    if (range.min <= rules.idealTo) return 1;
    if (range.min <= rules.partialTo) return 0.5;
    return 0;
  }

  return 0;
}

function afCriterionMatches(criterion, tagSet) {
  const options = ART_FINDER_CONFIG.synonyms[criterion] || [criterion];
  return options.some((option) => tagSet.has(afNormaliseTag(option)));
}

/* Het gekozen onderwerpantwoord, of null bij Surprise me / nog niets. */
function afOnderwerpAntwoord(answers) {
  const index = ART_FINDER_CONFIG.questions.findIndex((question) => question.group === 'subject');
  const given = index === -1 ? null : answers[index];
  if (given === null || given === undefined) return null;
  const answer = ART_FINDER_CONFIG.questions[index].answers[given];
  return answer && answer.set ? answer : null;
}

/* Welke variant van deze vraag geldt bij deze antwoorden? null = de standaardvraag. */
function afVariantSleutel(question, answers) {
  if (!question.variants) return null;
  const onderwerp = afOnderwerpAntwoord(answers);
  return onderwerp && question.variants[onderwerp.set] ? onderwerp.set : null;
}

/* De vraag zoals de bezoeker hem ziet: titel en antwoorden van de geldende variant. */
function afVraag(index, answers) {
  const question = ART_FINDER_CONFIG.questions[index];
  const sleutel = afVariantSleutel(question, answers);
  return sleutel ? { ...question, ...question.variants[sleutel] } : question;
}

/*
  Hoe sterk draagt een werk een kleur? 2 = dominant (de kleurtag), 1 = alleen
  als accent (de tag accent-<kleur> staat erbij, of alleen die), 0 = niet.
  De kleurtag zelf blijft staan, want de kleurcollecties filteren erop.
*/
function afKleurNiveau(kleur, tagSet) {
  const accent = tagSet.has(`${ART_FINDER_CONFIG.accentPrefix}${afNormaliseTag(kleur)}`);
  if (afCriterionMatches(kleur, tagSet)) return accent ? 1 : 2;
  return accent ? 1 : 0;
}

/* Hoort dit werk bij de harde set van het gekozen onderwerp? Zonder set: altijd. */
function afInOnderwerpSet(product, answer) {
  if (!answer || !answer.set) return true;
  const regel = ART_FINDER_CONFIG.subjectSets[answer.set];
  const tagSet = new Set((product.tags || []).map(afNormaliseTag));
  return regel.anyOf.some((tag) => afCriterionMatches(tag, tagSet)) && !regel.noneOf.some((tag) => afCriterionMatches(tag, tagSet));
}

/* Heeft het gekozen onderwerp een sterke voorkeur (Animals in Cars), en draagt dit werk die? */
function afHeeftVoorkeur(product, answer) {
  if (!answer || !answer.voorkeur) return false;
  return afCriterionMatches(answer.voorkeur, new Set((product.tags || []).map(afNormaliseTag)));
}

function afIsPurchasable(product) {
  return (product.variants || []).some((variant) => variant.available === true);
}

/* Aantal verschillende maatopties; beslist welke versie van een kunstwerk wint bij gelijke score. */
function afSizeOptionCount(product) {
  const maten = new Set();
  (product.variants || []).forEach((variant) => {
    const waarde = variant.option1 || variant.title;
    if (waarde) maten.add(String(waarde).trim().toLowerCase());
  });
  return maten.size;
}

/*
  Sleutel van het kunstwerk: de titel zonder productvormsegmenten.
  "Cool Mouse on Clogs | Canvas Print | 30 x 30"  ->  "cool mouse on clogs"
  "Mousy | Lime | Canvas Print | 30 x 30"         ->  "mousy lime"
*/
function afArtworkKey(title) {
  const delen = String(title || '')
    .split('|')
    .map((deel) => deel.trim())
    .filter(Boolean);

  const vormen = (ART_FINDER_CONFIG.dedupe && ART_FINDER_CONFIG.dedupe.formSegments) || [];
  const kern = delen.filter((deel) => {
    const waarde = deel.toLowerCase();
    if (/^\d+\s*[x×]\s*\d+(\s*cm)?$/.test(waarde)) return false;
    return !vormen.some((vorm) => waarde.indexOf(vorm) === 0);
  });

  const gebruikt = kern.length ? kern : delen.slice(0, 1);
  return gebruikt
    .join(' ')
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/* Deterministische tiebreak, zodat gelijke scores niet altijd dezelfde volgorde geven. */
function afHash(text) {
  let hash = 2166136261;
  const value = String(text);
  for (let i = 0; i < value.length; i += 1) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) / 4294967295;
}

class ArtFinderQuiz extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;
    this.initialised = true;

    this.root = this.dataset.root || '/';
    this.collectionHandle = afNormaliseTag(this.dataset.collection) || 'all';
    this.eligibilityTag = afNormaliseTag(this.dataset.eligibilityTag) || 'art-finder';
    this.resultsCount = Math.min(6, Math.max(4, parseInt(this.dataset.resultsCount, 10) || 6));
    this.cardSectionId = this.dataset.cardSection || 'art-finder-card';
    this.currency = this.dataset.currency || 'EUR';

    this.quizEl = this.querySelector('[data-art-finder-quiz]');
    this.resultsEl = this.querySelector('[data-art-finder-results]');
    this.gridEl = this.querySelector('[data-art-finder-grid]');
    this.summaryEl = this.querySelector('[data-art-finder-summary]');
    this.liveEl = this.querySelector('[data-art-finder-live]');

    this.answers = new Array(ART_FINDER_CONFIG.questions.length).fill(null);
    this.step = 0;
    this.products = null;
    this.productsPromise = null;

    this.renderQuestion(false);
  }

  /* ------------------------------ Vragen ------------------------------ */

  renderQuestion(animate = true) {
    const total = ART_FINDER_CONFIG.questions.length;
    const stepIndex = this.step;
    const question = afVraag(this.step, this.answers);
    let selected = this.answers[this.step];
    const isLast = this.step === total - 1;

    const isColourQuestion = question.type === 'colours';
    if (isColourQuestion) {
      /* Kleuren die geen kandidaat meer hebben mogen niet in de keuze blijven staan. */
      this.pruneColourAnswers();
      selected = this.answers[this.step];

      /*
        Zijn de producten er nog niet, dan tonen we kort een laadregel en
        verversen we deze vraag zodra de catalogus binnen is: de kleuren komen
        uit de matches, en die zijn zonder catalogus niet te berekenen.
      */
      if (!this.products) {
        this.loadProducts()
          .then(() => {
            /* alleen verversen als we nog op dezelfde vraag staan en de resultaten nog niet tonen */
            if (this.step === stepIndex && this.resultsEl.hidden) this.renderQuestion(false);
          })
          .catch(() => {});
      }
    }
    const chosenColours = isColourQuestion && Array.isArray(selected) ? selected : [];
    /* De kleurvraag mag altijd worden overgeslagen, de rest niet. */
    const nextDisabled = isColourQuestion ? false : selected === null;

    const body = isColourQuestion
      ? this.colourMarkup(question, chosenColours)
      : `<div class="art-finder__options">${question.answers
          .map((answer, index) => {
            const id = `ArtFinder-${question.id}-${index}`;
            return `
          <div class="art-finder__option-wrap">
            <input
              class="art-finder__input visually-hidden"
              type="radio"
              name="ArtFinder-${afEscape(question.id)}"
              id="${id}"
              value="${index}"
              ${selected === index ? 'checked' : ''}
            >
            <label class="art-finder__option" for="${id}">${afEscape(answer.label)}</label>
          </div>`;
          })
          .join('')}</div>`;

    this.quizEl.innerHTML = `
      <div class="art-finder__progress">
        <span class="art-finder__progress-label">${this.step + 1} ${afT('of', 'van')} ${total}</span>
        <span class="art-finder__bar">
          <span class="art-finder__bar-fill" style="width: ${((this.step + 1) / total) * 100}%"></span>
        </span>
      </div>
      <div class="art-finder__panel${animate ? ' art-finder__panel--enter' : ''}">
        <fieldset class="art-finder__fieldset">
          <legend class="art-finder__question h2">${afEscape(question.title)}</legend>
          ${question.subtitle ? `<p class="art-finder__subtitle">${afEscape(question.subtitle)}</p>` : ''}
          ${body}
        </fieldset>
        <div class="art-finder__nav">
          <button type="button" class="button button--tertiary art-finder__back" data-art-finder-back ${
            this.step === 0 ? 'hidden' : ''
          }>
            ${afT('Back', 'Terug')}
          </button>
          <button type="button" class="button" data-art-finder-next ${nextDisabled ? 'disabled' : ''}>
            ${isLast ? afT('See my results', 'Bekijk mijn resultaten') : afT('Next', 'Volgende')}
          </button>
        </div>
      </div>`;

    this.announce(`${afT('Question', 'Vraag')} ${this.step + 1} ${afT('of', 'van')} ${total}. ${question.title}`);

    if (isColourQuestion) {
      this.bindColourInputs(question);
    } else {
      this.quizEl.querySelectorAll('.art-finder__input').forEach((input) => {
        input.addEventListener('change', () => {
          const varianten = ART_FINDER_CONFIG.questions.map((q) => afVariantSleutel(q, this.answers));
          this.answers[this.step] = parseInt(input.value, 10);
          /* Andere variant van een vervolgvraag door dit antwoord: dat oude antwoord hoort bij een andere vraag. */
          ART_FINDER_CONFIG.questions.forEach((q, index) => {
            if (afVariantSleutel(q, this.answers) !== varianten[index]) this.answers[index] = null;
          });
          const next = this.quizEl.querySelector('[data-art-finder-next]');
          if (next) next.removeAttribute('disabled');
          /* Vast de producten ophalen zodra de eerste keuze valt, scheelt wachttijd. */
          this.loadProducts();
        });
      });
    }

    const backButton = this.quizEl.querySelector('[data-art-finder-back]');
    if (backButton) {
      backButton.addEventListener('click', () => {
        if (this.step === 0) return;
        this.step -= 1;
        this.renderQuestion();
        this.focusFirstOption();
      });
    }

    const nextButton = this.quizEl.querySelector('[data-art-finder-next]');
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        if (this.answers[this.step] === null) return;
        if (isLast) {
          this.showResults();
          return;
        }
        this.step += 1;
        this.renderQuestion();
        this.focusFirstOption();
      });
    }
  }

  /* ------------------------- Kandidaten ------------------------------ */

  /* De producten die volgens tag én beschikbaarheid mogen worden aanbevolen. */
  candidateProducts() {
    return (this.products || []).filter((product) => {
      const tagSet = new Set((product.tags || []).map(afNormaliseTag));
      if (!tagSet.has(this.eligibilityTag)) return false;
      if (ART_FINDER_CONFIG.requirePurchasable && !afIsPurchasable(product)) return false;
      return true;
    });
  }

  /* --------------------- Matches en kleurstap ----------------------- */

  /* De antwoorden zonder kleurkeuze: daarop rusten de oorspronkelijke matches. */
  antwoordenZonderKleur() {
    return this.answers.map((antwoord, index) => (ART_FINDER_CONFIG.questions[index].type === 'colours' ? [] : antwoord));
  }

  proefMet(antwoorden) {
    const proef = Object.create(ArtFinderQuiz.prototype);
    proef.answers = antwoorden;
    proef.eligibilityTag = this.eligibilityTag;
    proef.resultsCount = this.resultsCount;
    proef.products = this.products;
    return proef;
  }

  /*
    DE OORSPRONKELIJKE MATCHES: precies de uitslag die de bezoeker krijgt als
    hij bij de laatste stap niets kiest. Dezelfde rekenregel als altijd:
    formaat is een voorwaarde, de rest scoort met de vaste gewichten, de
    werken met punten gaan voor (minstens vier), en per kunstwerk één versie.
  */
  oorspronkelijkeMatches() {
    if (!this.products) return [];
    const proef = this.proefMet(this.antwoordenZonderKleur());
    let ranked = proef.score(this.products);
    /*
      Heeft het gekozen onderwerp in het gekozen formaat helemaal niets (kan
      bij de kleine set Animals in Cars), dan laten we het FORMAAT los, nooit
      het onderwerp: liever een werk in een ander formaat dan een lege uitslag
      of een werk buiten de gekozen categorie.
    */
    if (!ranked.length) ranked = proef.score(this.products, { formaatAlsFilter: false });
    const scorend = ranked.filter((entry) => entry.score > 0);
    const bron = scorend.length >= 4 ? scorend : ranked;
    const aantal = this.resultsCount || 6;

    /*
      Animals in Cars: eerst de autowerken; andere dieren vullen alleen aan
      als er niet genoeg autowerken zijn.
    */
    const antwoord = afOnderwerpAntwoord(this.answers);
    if (antwoord && antwoord.voorkeur) {
      const autos = proef.dedupe(bron.filter((entry) => afHeeftVoorkeur(entry.product, antwoord)), aantal);
      if (autos.length >= aantal) return autos;
      const gezien = new Set(autos.map((entry) => afArtworkKey(entry.product.title)));
      const overig = bron.filter((entry) => !afHeeftVoorkeur(entry.product, antwoord) && !gezien.has(afArtworkKey(entry.product.title)));
      return [...autos, ...proef.dedupe(overig, aantal - autos.length)];
    }
    return proef.dedupe(bron, aantal);
  }

  heeftKleur(answer, product) {
    const tagSet = new Set((product.tags || []).map(afNormaliseTag));
    return answer.tags.some((tag) => afKleurNiveau(tag, tagSet) > 0);
  }

  /* Bovenste rij: de kleuren die in de oorspronkelijke matches voorkomen. */
  matchKleuren(question) {
    const matches = this.oorspronkelijkeMatches().map((entry) => entry.product);
    return question.answers.filter((answer) => matches.some((product) => this.heeftKleur(answer, product)));
  }

  /*
    Onderste rij: alle andere kleuren waarvoor minstens één koopbaar
    Art Finder-werk bestaat binnen het gekozen onderwerp. Het onderwerp is een
    harde keuze; de overige eerdere antwoorden worden pas bij de uitslag zo
    veel mogelijk vastgehouden.
  */
  andereKleuren(question) {
    const bovenaan = new Set(this.matchKleuren(question).map((answer) => answer.tags[0]));
    const kandidaten = this.binnenOnderwerp(this.candidateProducts());
    return question.answers.filter(
      (answer) => !bovenaan.has(answer.tags[0]) && kandidaten.some((product) => this.heeftKleur(answer, product))
    );
  }

  /* De kleuren die de bezoeker bij de laatste stap kan KIEZEN: de bovenste én de onderste rij. */
  visibleColourAnswers(question) {
    if (!this.products) return [];
    return [...this.matchKleuren(question), ...this.andereKleuren(question)];
  }

  /*
    Het onderwerp is een harde keuze: wie Animals, Animals in Cars of Abstract koos, krijgt bij
    een andere kleur nooit een werk buiten dat onderwerp. "Surprise me" laat
    alles door.
  */
  binnenOnderwerp(producten) {
    const antwoord = afOnderwerpAntwoord(this.answers);
    return producten.filter((product) => afInOnderwerpSet(product, antwoord));
  }

  /*
    De eerdere antwoorden als losse criteria. Alleen antwoorden die iets
    vragen tellen: "Surprise me" en "I'm flexible" zijn geen criterium.
    Een formaatkeuze is voldaan als het werk in dat formaat koopbaar is.
  */
  criteria() {
    const lijst = [];
    ART_FINDER_CONFIG.questions.forEach((_, index) => {
      const question = afVraag(index, this.answers);
      if (question.type === 'colours') return;
      const given = this.answers[index];
      if (given === null || given === undefined) return;
      const answer = question.answers[given];
      if (!answer) return;
      if (question.group === 'size') {
        if (answer.size) lijst.push({ group: question.group, voldaan: (product) => afMatchesSizeBucket(product, answer.size) });
        return;
      }
      if (!answer.tags.length) return;
      lijst.push({
        group: question.group,
        voldaan: (product) => {
          const tagSet = new Set((product.tags || []).map(afNormaliseTag));
          return answer.tags.every((tag) => afCriterionMatches(tag, tagSet));
        },
      });
    });
    return lijst;
  }

  /*
    DE UITSLAG BIJ GEKOZEN KLEUREN (besluiten Tim, 24 sep 2026).

    Altijd het gewone aantal (6), zolang het onderwerp genoeg werken heeft.
    Eerst de werken binnen het onderwerp die één of meer gekozen kleuren
    dragen (OF), dominant of als accent; daarna aanvulling binnen het
    onderwerp, nooit daarbuiten. Binnen de werken in kleur:
      één kleur:     dominant vóór accent; daarbinnen bij Animals in Cars de
                     autowerken vóór de andere dieren (de kleur is primair);
      meer kleuren:  bij Animals in Cars de autowerken vóór de andere dieren
                     (het onderwerp is weer primair); daarbinnen dominant vóór
                     accent.
    In de aanvulling bij Animals in Cars de autowerken eerst. Overal daarna de
    meeste vastgehouden eerdere antwoorden, de quizscore en de vaste
    tiebreak. Per kunstwerk één versie.
  */
  kleurResultaten(gekozen) {
    if (!this.products || !gekozen.length) return [];
    const criteria = this.criteria();
    const antwoord = afOnderwerpAntwoord(this.answers);
    const kleurEerst = gekozen.length === 1;

    const gerangschikt = this.score(this.binnenOnderwerp(this.candidateProducts()), { formaatAlsFilter: false })
      .map((entry) => {
        const tagSet = new Set((entry.product.tags || []).map(afNormaliseTag));
        return {
          ...entry,
          kleur: Math.max(0, ...gekozen.map((tag) => afKleurNiveau(tag, tagSet))),
          auto: afHeeftVoorkeur(entry.product, antwoord) ? 1 : 0,
          voldaan: criteria.filter((c) => c.voldaan(entry.product)).length,
          criteria: criteria.length,
        };
      })
      .sort(
        (a, b) =>
          (b.kleur > 0) - (a.kleur > 0) ||
          (kleurEerst ? b.kleur - a.kleur || b.auto - a.auto : b.auto - a.auto || b.kleur - a.kleur) ||
          b.voldaan - a.voldaan ||
          b.score - a.score ||
          b.tiebreak - a.tiebreak
      );

    /* Per kunstwerk één versie: de eerste in deze volgorde is de beste. */
    const gezien = new Set();
    return gerangschikt
      .filter((entry) => {
        const sleutel = afArtworkKey(entry.product.title) || `__${entry.product.id}`;
        if (gezien.has(sleutel)) return false;
        gezien.add(sleutel);
        return true;
      })
      .slice(0, this.resultsCount || 6);
  }

  /*
    DE UITSLAG DIE DE BEZOEKER ZIET. Eén plek, zodat de tests precies dit pad
    toetsen. Niets gekozen bij de laatste stap: de oorspronkelijke matches.
    Wel kleuren gekozen: eerst werken in die kleuren, aangevuld tot het
    gewone aantal (zie kleurResultaten).
    "No preference" is hetzelfde als niets kiezen. Beide blijven binnen het
    gekozen onderwerp, ook het vangnet.
  */
  uitslag() {
    const kleurIndex = ART_FINDER_CONFIG.questions.findIndex((question) => question.type === 'colours');
    const gekozenKleuren = kleurIndex === -1 ? [] : this.answers[kleurIndex] || [];
    const selection = gekozenKleuren.length ? this.kleurResultaten(gekozenKleuren) : [];
    /* Vangnet voor het onwaarschijnlijke geval dat de catalogus intussen veranderde. */
    return selection.length ? selection : this.oorspronkelijkeMatches();
  }

  /* Een kleur die de laatste stap niet (meer) aanbiedt mag niet in de antwoorden blijven hangen. */
  pruneColourAnswers() {
    if (!this.products) return;
    ART_FINDER_CONFIG.questions.forEach((question, index) => {
      if (question.type !== 'colours') return;
      const gekozen = this.answers[index];
      if (!Array.isArray(gekozen) || !gekozen.length) return;
      const zichtbaar = new Set(this.visibleColourAnswers(question).map((a) => a.tags[0]));
      this.answers[index] = gekozen.filter((tag) => zichtbaar.has(tag));
    });
  }

  /* ---------------------------- Kleurvraag ---------------------------- */

  swatchMarkup(question, answers, chosen) {
    const check =
      '<svg class="art-finder__check" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<path d="M3.5 10.5l4 4 9-9" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    return answers
      .map((answer) => {
        const tag = answer.tags[0];
        const id = `ArtFinder-${question.id}-${afNormaliseTag(tag)}`;
        return `
          <div class="art-finder__swatch-wrap">
            <input
              class="art-finder__input art-finder__input--colour visually-hidden"
              type="checkbox"
              id="${id}"
              value="${afEscape(tag)}"
              ${chosen.indexOf(tag) !== -1 ? 'checked' : ''}
            >
            <label class="art-finder__swatch" for="${id}">
              <span
                class="art-finder__swatch-dot${answer.lightSwatch ? ' art-finder__swatch-dot--light' : ''}"
                style="--art-finder-swatch: ${afEscape(answer.swatch)}"
              >${check}</span>
              <span class="art-finder__swatch-label">${afEscape(answer.label)}</span>
            </label>
          </div>`;
      })
      .join('');
  }

  colourMarkup(question, chosen) {
    if (!this.products) {
      return `<p class="art-finder__loading" data-art-finder-colours-loading>${afT('Finding your matches…', 'Even je matches zoeken…')}</p>`;
    }
    const boven = this.matchKleuren(question);
    const onder = this.andereKleuren(question);
    const geen = question.noPreferenceLabel
      ? `<div class="art-finder__option-wrap art-finder__no-preference">
           <input class="art-finder__input art-finder__input--none visually-hidden" type="checkbox" id="ArtFinder-${afEscape(question.id)}-none" data-art-finder-none ${
             this.geenKleurvoorkeur && !chosen.length ? 'checked' : ''
           }>
           <label class="art-finder__option" for="ArtFinder-${afEscape(question.id)}-none">${afEscape(question.noPreferenceLabel)}</label>
         </div>`
      : '';
    return `
      ${geen}
      <div class="art-finder__swatches art-finder__swatches--top" data-art-finder-colours="matches">${this.swatchMarkup(question, boven, chosen)}</div>
      ${
        onder.length
          ? `<fieldset class="art-finder__more" data-art-finder-colours="other">
               <legend class="art-finder__more-title">${afEscape(question.otherTitle)}</legend>
               <p class="art-finder__subtitle">${afEscape(question.otherSubtitle)}</p>
               <div class="art-finder__swatches">${this.swatchMarkup(question, onder, chosen)}</div>
             </fieldset>`
          : ''
      }`;
  }

  bindColourInputs(question) {
    /* Geen maximum, tenzij de configuratie er een zet. */
    const max = question.maxChoices || Infinity;
    const colourInputs = [...this.quizEl.querySelectorAll('.art-finder__input--colour')];
    const labelFor = (tag) => {
      const match = question.answers.find((answer) => answer.tags[0] === tag);
      return match ? match.label.toLowerCase() : tag;
    };

    if (!Array.isArray(this.answers[this.step])) this.answers[this.step] = [];

    const geenInput = this.quizEl.querySelector('[data-art-finder-none]');
    const sync = () => {
      const chosen = this.answers[this.step];
      colourInputs.forEach((input) => {
        input.checked = chosen.indexOf(input.value) !== -1;
      });
      if (chosen.length) this.geenKleurvoorkeur = false;
      if (geenInput) geenInput.checked = !!this.geenKleurvoorkeur;
    };

    /* "No preference" zet alle kleuren uit; een kleur kiezen zet hem weer uit. */
    if (geenInput) {
      geenInput.addEventListener('change', () => {
        this.geenKleurvoorkeur = geenInput.checked;
        if (geenInput.checked) this.answers[this.step] = [];
        this.announce(
          geenInput.checked
            ? afT('No preference selected, all colours deselected.', 'Geen voorkeur gekozen, alle kleuren uitgezet.')
            : afT('No preference deselected.', 'Geen voorkeur uitgezet.')
        );
        sync();
      });
    }

    colourInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const chosen = this.answers[this.step];
        const position = chosen.indexOf(input.value);

        if (input.checked && position === -1) {
          chosen.push(input.value);
          /* Meer dan het maximum: de oudste keuze maakt plaats, niemand loopt vast. */
          if (chosen.length > max) {
            const dropped = chosen.shift();
            this.announce(
              afT(
                `${labelFor(input.value)} selected, ${labelFor(dropped)} deselected.`,
                `${labelFor(input.value)} gekozen, ${labelFor(dropped)} uitgezet.`
              )
            );
          } else {
            this.announce(afT(`${labelFor(input.value)} selected.`, `${labelFor(input.value)} gekozen.`));
          }
        } else if (!input.checked && position !== -1) {
          chosen.splice(position, 1);
          this.announce(afT(`${labelFor(input.value)} deselected.`, `${labelFor(input.value)} uitgezet.`));
        }

        sync();
      });
    });

    sync();
  }

  focusFirstOption() {
    /* Op de kleurvraag beginnen we bij de swatches, niet bij "No preference". */
    const colour = this.quizEl.querySelector('.art-finder__input--colour');
    const checkedColour = this.quizEl.querySelector('.art-finder__input--colour:checked');
    const checked = this.quizEl.querySelector('.art-finder__input:checked');
    const target = colour ? checkedColour || colour : checked || this.quizEl.querySelector('.art-finder__input');
    if (target) target.focus({ preventScroll: true });
  }

  announce(message) {
    if (this.liveEl) this.liveEl.textContent = message;
  }

  /* ---------------------------- Producten ---------------------------- */

  loadProducts() {
    if (this.productsPromise) return this.productsPromise;

    this.productsPromise = (async () => {
      const collected = [];
      for (let page = 1; page <= AF_MAX_PAGES; page += 1) {
        const url = `${this.root}collections/${this.collectionHandle}/products.json?limit=${AF_PAGE_SIZE}&page=${page}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Products request failed: ${response.status}`);
        const data = await response.json();
        const batch = data.products || [];
        collected.push(...batch);
        if (batch.length < AF_PAGE_SIZE) break;
      }
      this.products = collected;
      return collected;
    })();

    return this.productsPromise;
  }

  /* ------------------------------ Scoren ------------------------------ */

  score(products, { formaatAlsFilter = true } = {}) {
    const weights = ART_FINDER_CONFIG.weights;
    const signature = this.answers.join('-');

    /*
      Een gekozen formaat is een voorwaarde, geen suggestie: wie om een
      compact werk vraagt hoort geen werk van 135 cm terug te krijgen, ook
      niet als dat op alle andere punten prachtig matcht.
    */
    const sizeIndex = ART_FINDER_CONFIG.questions.findIndex((question) => question.group === 'size');
    const sizeGiven = sizeIndex === -1 ? null : this.answers[sizeIndex];
    const sizeAnswer =
      sizeGiven === null || sizeGiven === undefined ? null : ART_FINDER_CONFIG.questions[sizeIndex].answers[sizeGiven];
    const requiredBucket = sizeAnswer && sizeAnswer.size ? sizeAnswer.size : null;

    /*
      DE HARDE GRENS DIEREN / ABSTRACT (besluit Tim, 23 sep 2026). Animals en
      Animals in Cars: uitsluitend dierenwerken (autowerken horen daarbij),
      nooit abstract. Abstract: uitsluitend abstract, nooit dieren of auto's.
      Hoe sterk een ander werk ook scoort op sfeer, stijl, kleur of formaat.
      "Surprise me" legt niets vast.
    */
    const subjectAnswer = afOnderwerpAntwoord(this.answers);

    return products
      .map((product) => {
        const tagSet = new Set((product.tags || []).map(afNormaliseTag));
        if (!tagSet.has(this.eligibilityTag)) return null;
        /* Niet te koop is niet aan te bevelen; dit geldt voor elk product, zonder uitzonderingen. */
        if (ART_FINDER_CONFIG.requirePurchasable && !afIsPurchasable(product)) return null;
        if (formaatAlsFilter && requiredBucket && !afMatchesSizeBucket(product, requiredBucket)) return null;
        if (!afInOnderwerpSet(product, subjectAnswer)) return null;

        let total = 0;
        const contributions = {};

        ART_FINDER_CONFIG.questions.forEach((_, index) => {
          const question = afVraag(index, this.answers);
          const given = this.answers[index];
          const weight = weights[question.group] != null ? weights[question.group] : 1;
          let points = 0;

          if (question.type === 'colours') {
            /* Elke geraden kleur telt apart mee, dus twee rake kleuren tellen dubbel. */
            if (!Array.isArray(given) || !given.length) return;
            /* Een accentkleur telt half. */
            given.forEach((tag) => {
              points += (afKleurNiveau(tag, tagSet) / 2) * weight;
            });
          } else {
            if (given === null || given === undefined) return;
            const answer = question.answers[given];
            if (!answer) return;

            let ratio = 0;
            if (question.group === 'size') {
              ratio = afSizeScore(answer.size, product, tagSet);
            } else if (answer.tags.length) {
              const matched = answer.tags.filter((tag) => afCriterionMatches(tag, tagSet)).length;
              ratio = matched / answer.tags.length;
            }
            points = ratio * weight;
          }

          total += points;
          contributions[question.group] = points;
        });

        return { product, score: total, contributions, tiebreak: afHash(`${product.id}-${signature}`) };
      })
      .filter(Boolean)
      .sort((a, b) => b.score - a.score || b.tiebreak - a.tiebreak);
  }

  summarise(ranked) {
    const totals = {};
    ranked.forEach((entry) => {
      Object.keys(entry.contributions).forEach((group) => {
        totals[group] = (totals[group] || 0) + entry.contributions[group];
      });
    });

    const phrases = ART_FINDER_CONFIG.questions
      .map((_, index) => {
        const question = afVraag(index, this.answers);
        const given = this.answers[index];
        let phrase = '';

        if (question.type === 'colours') {
          const chosen = Array.isArray(given) ? given : [];
          if (!chosen.length) return null;
          const labels = chosen.map((tag) => {
            const match = question.answers.find((answer) => answer.tags[0] === tag);
            return (match ? match.label : tag).toLowerCase();
          });
          /* Engels: "blue and red tones". Nederlands zonder "tinten" (anders "blauw tinten"): "blauw en rood". */
          const en = afT('and', 'en');
          const tinten = afT(' tones', '');
          phrase =
            labels.length > 1
              ? `${labels.slice(0, -1).join(', ')} ${en} ${labels[labels.length - 1]}${tinten}`
              : `${labels[0]}${tinten}`;
        } else {
          if (given === null || given === undefined) return null;
          const answer = question.answers[given];
          if (!answer) return null;
          phrase = answer.phrase;
        }

        if (!phrase) return null;
        return { phrase, weight: totals[question.group] || 0 };
      })
      .filter(Boolean)
      .sort((a, b) => b.weight - a.weight)
      .filter((item) => item.weight > 0)
      .slice(0, 3)
      .map((item) => item.phrase);

    if (!phrases.length) {
      return afT(
        "Based on your answers, we've picked the works we think you'll like most.",
        'Op basis van je antwoorden heb ik de werken uitgekozen die je volgens mij het mooist vindt.'
      );
    }

    let list = phrases[0];
    if (phrases.length === 2) list = `${phrases[0]} ${afT('and', 'en')} ${phrases[1]}`;
    if (phrases.length === 3) list = `${phrases[0]}, ${phrases[1]} ${afT('and', 'en')} ${phrases[2]}`;

    return afT(
      `Based on your answers, we've picked the works that best match your love of ${list}.`,
      `Op basis van je antwoorden heb ik de werken uitgekozen die het best passen bij jouw voorkeur voor ${list}.`
    );
  }

  /*
    Houdt per kunstwerk één versie over. De best scorende wint; bij een
    gelijke score de versie met de meeste maatopties, en staat ook dat
    gelijk dan de versie die al hoger in de ranglijst stond. Daarmee is de
    uitkomst volledig deterministisch: geen muntje.

    Vangnet: blijven er te weinig werken over, dan worden de overgeslagen
    versies alsnog aangevuld, zodat de quiz nooit met een halve lijst eindigt.
  */
  dedupe(entries, count) {
    if (!ART_FINDER_CONFIG.dedupe || !ART_FINDER_CONFIG.dedupe.enabled) {
      return entries.slice(0, count);
    }

    const beste = new Map();
    const overgeslagen = [];

    entries.forEach((entry, positie) => {
      const sleutel = afArtworkKey(entry.product.title);
      if (!sleutel) {
        beste.set(`__zonder-sleutel-${positie}`, { entry, positie });
        return;
      }

      const huidig = beste.get(sleutel);
      if (!huidig) {
        beste.set(sleutel, { entry, positie });
        return;
      }

      const winnaar = this.besteVersie(huidig, { entry, positie });
      beste.set(sleutel, winnaar);
      overgeslagen.push(winnaar === huidig ? entry : huidig.entry);
    });

    const uniek = [...beste.values()]
      .sort((a, b) => b.entry.score - a.entry.score || a.positie - b.positie)
      .map((rij) => rij.entry);

    const resultaat = uniek.slice(0, count);
    for (let i = 0; resultaat.length < count && i < overgeslagen.length; i += 1) {
      resultaat.push(overgeslagen[i]);
    }
    return resultaat;
  }

  besteVersie(a, b) {
    if (b.entry.score !== a.entry.score) return b.entry.score > a.entry.score ? b : a;
    const maatA = afSizeOptionCount(a.entry.product);
    const maatB = afSizeOptionCount(b.entry.product);
    if (maatA !== maatB) return maatB > maatA ? b : a;
    return a.positie <= b.positie ? a : b;
  }

  /* ---------------------------- Resultaten ---------------------------- */

  async showResults() {
    this.quizEl.hidden = true;
    this.resultsEl.hidden = false;
    this.summaryEl.textContent = '';
    this.gridEl.innerHTML = Array.from({ length: this.resultsCount })
      .map(() => '<li class="grid__item"><span class="art-finder__skeleton"></span></li>')
      .join('');
    this.announce(afT('Loading your results.', 'Je resultaten worden geladen.'));
    this.resultsEl.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });

    let products;
    try {
      products = await this.loadProducts();
    } catch (error) {
      console.error('[art-finder]', error);
      this.renderError();
      return;
    }

    /* Laatste zekerheid: een kleur zonder kandidaten telt nooit mee in de score. */
    this.pruneColourAnswers();

    const selection = products.length ? this.uitslag() : [];
    if (!selection.length) {
      this.renderError(
        afT(
          `No artworks are available for the quiz right now. Make sure products carry the tag "${this.eligibilityTag}" and can be purchased.`,
          'Er zijn op dit moment geen kunstwerken beschikbaar voor de quiz. Kijk gerust rond in de winkel.'
        )
      );
      return;
    }

    this.summaryEl.textContent = this.summarise(selection);
    await this.renderCards(selection);
    this.announce(afT(`${selection.length} artworks found.`, `${selection.length} kunstwerken gevonden.`));

    const changeColour = this.resultsEl.querySelector('[data-art-finder-change-colour]');
    if (changeColour && !changeColour.dataset.bound) {
      changeColour.dataset.bound = 'true';
      changeColour.addEventListener('click', () => this.backToColour());
    }

    const retake = this.resultsEl.querySelector('[data-art-finder-retake]');
    if (retake && !retake.dataset.bound) {
      retake.dataset.bound = 'true';
      retake.addEventListener('click', () => this.reset());
    }
  }

  async renderCards(selection) {
    const markup = await Promise.all(selection.map((entry) => this.cardMarkup(entry.product)));
    this.gridEl.innerHTML = markup.map((card) => `<li class="grid__item">${card}</li>`).join('');
  }

  /* Laat het theme de kaart renderen, zodat prijs, valuta en styling exact kloppen. */
  async cardMarkup(product) {
    const url = `${this.root}products/${product.handle}?section_id=${this.cardSectionId}`;

    /* Eén herkansing: een enkele hapering mag geen uitgeklede kaart opleveren. */
    for (let poging = 0; poging < 2; poging += 1) {
      try {
        if (poging > 0) await new Promise((resolve) => setTimeout(resolve, 400));
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Card request failed: ${response.status}`);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const card = parsed.querySelector('[data-art-finder-card]');
        if (card && card.innerHTML.trim()) return card.innerHTML;
        throw new Error('Card markup empty');
      } catch (error) {
        if (poging === 1) {
          console.error('[art-finder]', error);
          return this.fallbackCard(product);
        }
      }
    }

    return this.fallbackCard(product);
  }

  fallbackCard(product) {
    const image = (product.images && product.images[0]) || null;
    const price = product.variants && product.variants[0] ? product.variants[0].price : null;
    let priceLabel = '';
    const onRequest = Array.isArray(product.tags) && product.tags.includes('price-on-request');
    if (onRequest) {
      priceLabel = afT('Price on request', 'Prijs op aanvraag');
    } else if (price) {
      try {
        priceLabel = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.currency,
        }).format(parseFloat(price));
      } catch (error) {
        priceLabel = price;
      }
    }

    return `
      <div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--standard card--media">
          <div class="card__inner ratio" style="--ratio-percent: 100%;">
            ${
              image
                ? `<div class="card__media"><div class="media media--transparent">
                     <img src="${afEscape(image.src)}&width=533" alt="${afEscape(product.title)}" loading="lazy" width="533" height="533">
                   </div></div>`
                : ''
            }
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading">
                <a href="${this.root}products/${afEscape(product.handle)}" class="full-unstyled-link">${afEscape(
      product.title
    )}</a>
              </h3>
              ${
                priceLabel
                  ? `<div class="card-information">
                       <div class="price">
                         <div class="price__container">
                           <div class="price__regular">
                             <span class="price-item price-item--regular">${afEscape(priceLabel)}</span>
                           </div>
                         </div>
                       </div>
                     </div>`
                  : ''
              }
            </div>
          </div>
        </div>
      </div>`;
  }

  renderError(message) {
    this.gridEl.innerHTML = '';
    this.summaryEl.innerHTML = `<span class="art-finder__error">${afEscape(
      message || afT("We couldn't load the artworks right now. Please try again.", 'De kunstwerken konden nu niet worden geladen. Probeer het nog een keer.')
    )}</span>`;
    this.announce(message || afT('Something went wrong loading the results.', 'Er ging iets mis bij het laden van de resultaten.'));
  }

  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Terug naar de kleurvraag: vraag 1 t/m 6 en de gekozen kleur blijven staan. */
  backToColour() {
    const kleurIndex = ART_FINDER_CONFIG.questions.findIndex((question) => question.type === 'colours');
    if (kleurIndex === -1) return;
    this.step = kleurIndex;
    this.resultsEl.hidden = true;
    this.gridEl.innerHTML = '';
    this.summaryEl.textContent = '';
    this.quizEl.hidden = false;
    this.renderQuestion();
    this.quizEl.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    this.focusFirstOption();
  }

  reset() {
    this.answers = new Array(ART_FINDER_CONFIG.questions.length).fill(null);
    this.geenKleurvoorkeur = false;
    this.step = 0;
    this.resultsEl.hidden = true;
    this.gridEl.innerHTML = '';
    this.summaryEl.textContent = '';
    this.quizEl.hidden = false;
    this.renderQuestion();
    this.quizEl.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    this.focusFirstOption();
  }
}

if (!customElements.get('art-finder-quiz')) {
  customElements.define('art-finder-quiz', ArtFinderQuiz);
}
